import classnames from "classnames";
import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import ContactUs from "../../components/common/ContactUs/ContactUs";
import classes from "../../styles/Resources.module.scss";
import Banner from "../../components/common/Banner/Banner";
import BannerType from "../../global/banner-type";
import resources from "../../assets/images/resources.png";
import { ourChannels } from "../../global/constant";
import { nanoid } from "nanoid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import VoiceApIs from "./components/voiceAPIs";
import { APP_PATH } from "../../routes/route";
import SMS from "./components/SMS";
import GoogleRCS from "./components/GoogleRCS";
import WhatsApp from "./components/WhatsApp";
import TwitterDMs from "./components/TwitterDMs";
import Email from "./components/Email";
import useIsMobile from "../../components/hooks/useIsMobile";

const ChannelsPage = ({ page = "channels" }) => {
  const isMobile = useIsMobile({ breakpoint: 992 });
  const [activeTab, setActiveTab] = useState(page);
  const navigate = useNavigate();
  const handleClick = para => {
    setActiveTab(para);
    if (para !== "") {
      navigate(`${APP_PATH}/channels/${para}`);
    } else {
      navigate(`${APP_PATH}/channels`);
    }
  };
  return (
    <>
      <Header
        page={activeTab === "channels" ? activeTab : `channels/${activeTab}`}
      />
      <div
        className={classnames(
          "container containerWidth minheightCont100vh",
          classes.container
        )}
      >
        <div className={classnames(classes.sidebar)}>
          <div
            className={classnames(classes.heading)}
            onClick={() => handleClick("")}
          >
            Our Channels
          </div>
          <ul className={classnames(classes.menuList)}>
            {ourChannels.map(tab => {
              return (
                <li
                  className={`${activeTab === tab.id ? classes.active : ""}`}
                  onClick={() => handleClick(tab.id)}
                  key={nanoid()}
                >
                  {tab.title}
                </li>
              );
            })}
          </ul>
        </div>
        {(() => {
          switch (activeTab.toLowerCase()) {
            case "voiceapis":
              return <VoiceApIs />;
            case "sms":
              return <SMS />;
            case "googlercs":
              return <GoogleRCS />;
            case "whatsapp":
              return <WhatsApp />;
            case "email":
              return <Email />;
            case "contactus":
              return <ContactUs classname={classes.contactUs} />;
            default:
              return <Channels callbackfnc={handleClick} />;
          }
        })()}
        {!isMobile && <Footer className={classes.footerClass} />}
      </div>
      {isMobile && <Footer />}
    </>
  );
};

const Channels = ({ callbackfnc }) => {
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="Our Channels"
          description="The specific product, service, or approach offered by a company to address a particular problem or need."
          image={resources}
          maxWidth={214}
        />
      </div>
      <div className={classnames(classes.grid_box)}>
        {ourChannels.map(channel => {
          return (
            <div key={nanoid()} onClick={() => callbackfnc(channel.id)}>
              <Banner type={BannerType.SIMPLE_BANNER} {...channel} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChannelsPage;
